<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item>
            <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="24" :md="24">
        <el-input v-model="filtro.origem" placeholder="Origem (central, etc.)"></el-input>
      </el-col>      
    </el-row>

    <el-row :gutter="10" class="u-mb-10">
      <el-col :xs="24" :sm="16" :md="16">
        <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Data inicial"></el-date-picker>
        <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Data final" class="u-ml-10"></el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        <el-button type="primary" @click="abrirCadastro">NOVA DISTRIBUIÇÃO</el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th style="width: 110px;">Envio</th>
            <th style="width: 110px;">Recebido em</th>
            <th>Origem</th>
            <th style="width: 110px;">Status</th>
            <th style="width: 240px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ formatDateBR(item.data_envio) }}</td>
            <td>{{ formatDateBR(item.data_recebimento) }}</td>
            <td class="u-uppercase">{{ item.origem || '-' }}</td>
            <td>
              <el-tag size="mini" :type="item.status === 'recebida' ? 'success' : (item.status === 'cancelada' ? 'danger' : 'info')">
                {{ (item.status || 'enviada').toUpperCase() }}
              </el-tag>
            </td>
            <td class="u-text-center acao">
              <el-button v-if="item.status !== 'recebida'" class="u-mr-10" @click="abrirRecebimento(item)" title="Confirmar recebimento" type="success" icon="el-icon-check" size="mini" plain></el-button>
              <router-link :to="linkEdit(item.id)" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>

      <el-dialog title="Confirmar Recebimento" :visible.sync="dialogRecebimento.visible" width="500px">
        <el-form label-position="top">
          <el-form-item label="Data do recebimento">
            <el-date-picker v-model="dialogRecebimento.data_recebimento" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
          </el-form-item>
          <el-form-item label="Recebido por">
            <el-input v-model="dialogRecebimento.recebido_por" maxlength="191"></el-input>
          </el-form-item>
          <el-form-item label="Observações">
            <el-input type="textarea" :rows="3" v-model="dialogRecebimento.observacao_recebimento" maxlength="500"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogRecebimento.visible = false">CANCELAR</el-button>
          <el-button type="primary" @click="confirmarRecebimento">CONFIRMAR</el-button>
        </span>
      </el-dialog>

      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>

      <el-row :gutter="10" v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-text-left u-mt-10">
            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: {
      instituicao_id: '',
      instituicao: { id: '', nome: '' },
      data_inicio: '',
      data_fim: '',
      origem: ''
    },
    paginate: { page: 1, qtdItens: null, from: '', to: '' },
    items: [],
    dialogRecebimento: { visible: false, id: '', data_recebimento: '', recebido_por: '', observacao_recebimento: '' }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    if (this.$store.state.config.instituicao) {
      this.filtro.instituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
    this.load()
  },
  methods: {
    abrirCadastro () {
      if (!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id) {
        window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de registrar uma distribuição.', type: 'warning' })
        return
      }
      this.$router.push({
        path: '/admin/merenda/distribuicao/cadastro',
        query: { instituicao_id: this.$store.state.config.instituicao.id }
      })
    },
    linkEdit (id) {
      const inst = this.$store.state.config.instituicao
      return {
        path: '/admin/merenda/distribuicao/edit/' + id,
        query: (inst && inst.id) ? { instituicao_id: inst.id } : {}
      }
    },
    async changeInstituicao () {
      if (this.exibeSelectInstituicao) {
        await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id)
      }
      this.paginate.page = 1
      this.load()
    },
    load () {
      this.statusList = false
      this.items = []
      this.filtro.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : ''
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    abrirRecebimento (item) {
      this.dialogRecebimento = {
        visible: true,
        id: item.id,
        data_recebimento: new Date().toISOString().slice(0, 10),
        recebido_por: '',
        observacao_recebimento: ''
      }
    },
    confirmarRecebimento () {
      window.eventBus.$emit('loading', true)
      this.$axios.post(
        `${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao/confirmar-recebimento/` + this.dialogRecebimento.id,
        this.dialogRecebimento,
        this.$store.getters.getHeaderAuth
      ).then(response => {
        window.eventBus.$emit('loading', false)
        if (response.data && response.data.erro) {
          const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao confirmar recebimento.')
          return window.eventBus.$emit('alert', { msg, type: 'warning' })
        }
        this.dialogRecebimento.visible = false
        window.eventBus.$emit('alert', { msg: 'Recebimento confirmado.', type: 'success' })
        this.load()
      }).catch(error => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir esta distribuição? (Isso remove as entradas de estoque)', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) {
      this.paginate.page = page
      this.load()
    },
    formatDateBR (value) {
      if (!value) return '-'
      if (value instanceof Date) return value.toLocaleDateString('pt-BR')

      let s = value
      if (typeof value === 'object' && value.date) s = value.date
      s = String(s)

      let datePart = s
      if (datePart.includes(' ')) datePart = datePart.split(' ')[0]
      if (datePart.includes('T')) datePart = datePart.substring(0, 10)

      let dt = new Date(datePart + 'T00:00:00')
      if (isNaN(dt.getTime())) dt = new Date(String(value).replace(' ', 'T'))
      if (isNaN(dt.getTime())) return String(value)

      return dt.toLocaleDateString('pt-BR')
    }
  }
}
</script>

